var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBbBarbados(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_7661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#00267F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0029 0H19.9967V45H40.0029V0Z",
    fill: "#FFC726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0188 12.7031C30.675 14.4844 31.3313 16.3219 32.7563 17.7375C32.3157 17.5875 31.5375 17.4562 31.05 17.475V24.9281L33.15 25.2375C33.225 25.2375 33.2438 25.1156 33.2438 24.9563C33.45 22.6406 33.9938 20.6906 34.6313 18.675C34.6782 18.4031 35.475 17.3625 34.8563 17.55C34.7813 17.55 33.9657 17.8875 34.0875 17.7281C35.2654 16.5401 36.7873 15.7529 38.4375 15.4781C38.5782 15.45 38.6625 15.525 38.5313 15.6844C36.4313 18.9281 34.6594 22.7625 34.6782 27.3094C33.8532 27.3094 31.8657 26.8219 31.05 26.8219V32.0813H30L29.7657 17.3906L30.0188 12.7031Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_7661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbBarbados);
export default __webpack_public_path__ + "static/media/bb Barbados.37c89f935dcd0e5eab2b30e59e675265.svg";
export { ForwardRef as ReactComponent };